/**
 * @file Contém as constantes da aplicacao
 */
const constantes = {
    limiteLancamentos: 2000, // Limite máximo

    tiposDeIdentificadores: '/v1/reativaBH/buscarTiposDeIdentificadores',
    quantidadeDeLancamentos: '/v1/reativaBH/quantidadeDeLancamentos',
    buscarContribuinte: '/v1/reativaBH/buscarContribuinte',
    agrupaLancamentos: '/v1/reativaBH/agrupaLancamentos',
    imprimeSimulacao: '/v1/reativaBH/imprimeSimulacao',
    imprimeTermoCancelamento: '/v1/reativaBH/imprimeTermoCancelamento',
    retornaCalculos: '/v1/reativaBH/retornaCalculos',
    recuperaEnderecoCep: '/v1/reativaBH/recuperaEnderecoCep',
    retornaGuiaAVista: '/v1/reativaBH/retornaGuiaAVista',
    retornaGuiaParcelamentos: '/v1/reativaBH/retornaGuiaParcelamentos',
    confirmarCancelamento: '/v1/reativaBH/confirmarCancelamento',
    geraRelacaoLancamento: '/v1/reativaBH/geraRelacaoLancamento',
    enviarEmailCancelamentoParcelamento: '/v1/reativaBH/enviarEmailCancelamentoParcelamento',
    enviarMensagemCancelamentoParcelamento: '/v1/reativaBH/enviarMensagemCancelamentoParcelamento',
    buscarCNPJRelacionados: '/v1/reativaBH/buscarCNPJRelacionados',
    verificaPermissao: '/v1/reativaBH/verificaPermissao',
}

export default constantes;
